import styled from '@emotion/styled';
import { pressActionEffect } from '@styles/mixin';
import { useTranslation } from 'react-i18next';

import useReadAllNotifications from './hooks/useReadAllNotifications';

function ReadAllButton() {
    const { t } = useTranslation('notification');
    const readAll = useReadAllNotifications();
    return (
        <Container>
            <Button type='button' onClick={readAll}>
                {t('readAll')}
            </Button>
        </Container>
    );
}

const Container = styled.div`
    padding: var(--spacing-4) var(--spacing-4) 0;
    width: 100%;
`;

const Button = styled.button`
    align-items: center;
    background-color: var(--color-white);
    border: 1px solid var(--color-gray3);
    border-radius: var(--radius-xs);
    color: var(--color-text-primary);
    display: flex;
    font-size: var(--font-size-body-short);
    font-weight: 500;
    height: 36px;
    justify-content: center;
    line-height: 1.4;
    padding: var(--spacing-2) var(--spacing-4);
    width: 100%;
    ${pressActionEffect}
`;

export default ReadAllButton;
